<template lang='pug'>
    div.stretch(v-if="opts.actionbar")
      div
        a(v-if="opts.creatable" @click='create({}, 0)')
          i(style="font-size:14px",class='el-icon-plus', title='增加')

      template(v-if="opts.sharable")
        popover(:showConfirm='true', @confirm='share', :width=400)
          span(slot="trigger")
            i.a(style="font-size:14px",class="el-icon-share", title="分享给")
          div 权限：&nbsp;
            el-radio-group(v-model="permission" size="small")
              el-radio-button(label="读取") 读取
              el-radio-button(label="读写") 读写
              el-radio-button(label="所有") 所有
          div 用户
            spreadsheet(ref='to_users', :opts='user_opts')

      popover(v-if="opts.removable != false")
        span(slot="trigger")
          i.a(style="font-size:14px",class="el-icon-delete", title="删除选中的数据")
        div 确定删除选中的数据？
        div.a(@click='remove') 确定

      popover(:width=80)
        span(slot='trigger')
          i.a(style="font-size:14px",class='el-icon-menu', title='操作')
        xlsx-import(v-if='opts.importable' :opts='opts')
        hr(v-if='opts.importable')
        popover(text='隐藏列…' :autoClose='false')
          div(v-for="(v, k) in columnHidden")
            el-checkbox(v-model='columnHidden[k]' @change='setColumnHidden')
            span {{k}}
        //- div
        //-   a(@click="hideRow" style="font-size:13px;") 隐藏选中行
        //- div
        //-   a(@click="showAllRow" style="font-size:13px;") 显示所有行
        slot(name='actions')
</template>

<script>
// Generated by CoffeeScript 2.3.0
let m

// import {xlsxImport} from '../../commons';

export default (m = {
  // components: {xlsxImport},
  props: {
    opts: Object,
    columnHidden: Object,
  },
  data() {
    return {
      user_opts: {
        tableName: 'users',
        columns: [
          {
            label: 'account',
          },
        ],
        actionbar: false,
        editable: false,
      },
      group_opts: {
        tableName: 'groups',
        columns: [
          {
            label: '组名',
          },
        ],
        actionbar: false,
        editable: false,
      },
      permission: '读写',
    }
  },
  methods: {
    remove() {
      return this.$emit('remove')
    },
    create() {
      return this.$emit('create')
    },
    share() {
      return this.$emit('share', this.$refs.to_users.getChecked(), this.permission)
    },
    hideRow() {
      return this.$emit('hideRow')
    },
    showAllRow() {
      return this.$parent.showAllRow()
    },
    setColumnHidden(k) {
      return this.$emit('setColumnHidden', k)
    },
  },
})
</script>

